import { CustomerInfoType } from '@/types/widgetConfig';
import { atom } from 'jotai';

type CustomerInfoState = {
  isInitialized: boolean;
  customerInfo?: CustomerInfoType;
};

export const customerInfoAtom = atom<CustomerInfoState>({
  isInitialized: false,
  customerInfo: {}
});
